// @ts-nocheck
export class UiState {
  focusRun?: number
}
